const messages = {
  en: {
    meta: {
      htmlLang: "en",
      language: "English",
    },
    app: {
      titlePublic: "Blood on the Clocktower Town Square",
      titleGrimoire: "Blood on the Clocktower Grimoire",
    },
    common: {
      back: "Back",
      by: "by",
      close: "Close",
      customScript: "Custom Script",
      search: "Search",
    },
    language: {
      label: "Language",
      english: "English",
      russian: "Russian",
    },
    teams: {
      townsfolk: "Townsfolk",
      outsider: "Outsider",
      minion: "Minion",
      demon: "Demon",
      traveller: "Traveller",
      fabled: "Fabled",
      loric: "Loric",
      jinxed: "Jinxed",
    },
    intro: {
      welcome: "Welcome to the (unofficial)",
      title: "Virtual Town Square and Grimoire",
      forClocktower: "for Blood on the Clocktower!",
      addPlayersBeforeMenu: "Please add more players through the",
      menu: "Menu",
      addPlayersAfterMenu:
        "on the top right or by pressing {addKey}. You can also join a game session by pressing {joinKey}.",
      footerBeforeGithub:
        "This project is free and open source and can be found on",
      footerAfterGithub:
        'It is not affiliated with The Pandemonium Institute. "Blood on the Clocktower" is a trademark of Steven Medway and The Pandemonium Institute.',
      chineseRedirect: "Want to use the Chinese version?",
    },
    menu: {
      recentNominations: [
        "{count} recent nomination",
        "{count} recent nominations",
      ],
      sessionSummary: "{count} other players in this session",
      sessionLatency: "{latency}ms latency",
      grimoire: "Grimoire",
      hide: "Hide",
      show: "Show",
      switchToNight: "Switch to Night",
      switchToDay: "Switch to Day",
      nightOrder: "Night Order",
      zoom: "Zoom",
      backgroundImage: "Background Image",
      useUnofficialArt: "Use Unofficial Art",
      showCustomImages: "Show Custom Images",
      disableAnimations: "Disable Animations",
      muteSounds: "Mute Sounds",
      playing: "Playing",
      hosting: "Hosting",
      liveSession: "Live Session",
      host: "Host (Storyteller)",
      join: "Join (Player)",
      delayToHost: "Delay to Host",
      delayToPlayers: "Delay to Players",
      copyPlayerLink: "Copy Player Link",
      sendCharacters: "Send Characters",
      voteHistory: "Vote History",
      secretVote: "Secret Vote",
      votingTwice: "Voting Twice",
      leaveSession: "Leave Session",
      players: "Players",
      add: "Add",
      allowSelfNaming: "Allow Self-Naming",
      lowerAllHands: "Lower All Hands",
      randomize: "Randomize",
      removeAll: "Remove All",
      characters: "Characters",
      selectEdition: "Select Edition",
      chooseAssign: "Choose & Assign",
      addNpcs: "Add NPCs",
      clearAll: "Clear All",
      help: "Help",
      referenceSheet: "Reference Sheet",
      nightOrderSheet: "Night Order Sheet",
      gameStateJson: "Game State JSON",
      mockAssignments: "Mock Assignments",
      joinDiscord: "Join Unofficial Discord",
      sourceCode: "Source Code",
      prompts: {
        background: "Enter custom background URL",
        sessionHost: "Enter a channel number / name for your session",
        sessionJoin: "Enter the channel number / name of the session you want to join",
        distributeRoles:
          "Do you want to distribute assigned characters to all SEATED players?",
        imageOptIn:
          "Are you sure you want to allow custom images? A malicious script file author might track your IP address this way.",
        leaveSession: "Are you sure you want to leave the active live game?",
        playerName: "Player name",
        defaultPlayerName: "Player {number}",
        randomizeSeats: "Are you sure you want to randomize seatings?",
        removePlayers: "Are you sure you want to remove all players?",
        removeRoles: "Are you sure you want to remove all player roles?",
      },
    },
    townInfo: {
      addMorePlayers: "Please add more players!",
      nightPhase: "Night phase",
      editionByAuthor: "{name} by {author}",
    },
    townSquare: {
      otherCharacters: "Other Characters",
      demonBluffs: "Demon Bluffs",
      npcs: "NPCs",
      removePlayer: "Do you really want to remove {name}?",
      firstNight: "First Night",
      otherNights: "Other Nights",
    },
    player: {
      ghostVote: "Ghost vote",
      hasTwoVotes: "Has two votes",
      wasNominated: "Was nominated",
      hasNominated: "Has nominated",
      handUp: "Hand UP",
      secondHandUp: "Second Hand UP",
      handDown: "Hand DOWN",
      voteUnknown: "Vote hidden",
      cancel: "Cancel",
      swapWithPlayer: "Swap seats with this player",
      moveToSeat: "Move player to this seat",
      nominatePlayer: "Nominate this player",
      raiseHand: "Raise Hand",
      changeAlignment: "Change Alignment",
      changePronouns: "Change Pronouns",
      rename: "Rename",
      movePlayer: "Move Player",
      swapSeats: "Swap Seats",
      remove: "Remove",
      emptySeat: "Empty Seat",
      cancelNomination: "Cancel Nomination",
      nomination: "Nomination",
      claimSeat: "Claim seat",
      vacateSeat: "Vacate Seat",
      seatOccupied: "Seat Occupied",
      pronounsPrompt: "Player pronouns",
      namePrompt: "Player name",
      yourClaimedSeat: "Your claimed seat",
      seatClaimedBy: "Seat claimed by {name}",
      yourReservedSeat: "Your reserved seat. Click 'Claim seat' to reconnect",
      seatReservedFor: "Seat reserved for {name}",
    },
    vote: {
      nominated: "nominated",
      votes: ["{count} vote", "{count} votes"],
      inFavor: "in favor",
      secretInProgress: "The vote is secret",
      majorityIs: "majority is {count}",
      timePerPlayer: "Time per player:",
      unoccupiedSeats: "Some seats are unoccupied",
      countdown: "Countdown",
      restart: "Restart",
      start: "Start",
      pause: "Pause",
      resume: "Resume",
      reset: "Reset",
      markForExecution: "Mark for execution",
      clearMark: "Clear mark",
      secondsBetweenVotes: "{count} seconds between votes",
      claimSeat: "Please claim a seat to vote.",
      reclaimSeat: "Please reclaim your seat to vote.",
      go: "GO",
    },
    timer: {
      title: "Timer",
      presets: "Quick timer presets",
      minutes: "Minutes",
      seconds: "Seconds",
      minutesShort: "min",
      secondsShort: "sec",
      adjustTime: "Adjust time",
      sound: "Play a sound when time is up",
      start: "Start",
      pause: "Pause",
      resume: "Resume",
      stop: "Stop",
      close: "Close",
      addThirtySeconds: "+30 seconds",
      subtractThirtySeconds: "-30 seconds",
      addMinute: "+1 minute",
      subtractMinute: "-1 minute",
      remaining: "remaining",
      paused: "paused",
      timeUp: "time is up",
      openControls: "Open timer controls",
    },
    dayTracker: {
      title: "Day and night",
      day: "Day",
      night: "Night",
      dayLabel: "Day {number}",
      nightLabel: "Night {number}",
      notStarted: "Game not started",
      phaseNumber: "Number",
      decreaseNumber: "Decrease phase number",
      increaseNumber: "Increase phase number",
      openCorrection: "Open day and night correction",
      sequenceHint:
        "The game starts with Night 1, followed by Day 1. Use the phase buttons and number controls to correct an accidental switch.",
      hasNominated: "This player has nominated today",
      wasNominated: "This player was nominated today",
      warnings: {
        deadNominator: "the nominator is dead",
        nominatorUsed: "the nominator has already nominated today",
        nomineeUsed: "the nominee has already been nominated today",
        override:
          "This nomination is normally unavailable:\n{reasons}\n\nContinue as a character ability or Storyteller exception?",
      },
    },
    roleModal: {
      regular: "Regular",
      good: "Good",
      evil: "Evil",
      chooseCharacterFor: "Choose a new character for {name}:",
      bluffing: "bluffing",
      editionRoles: "Edition Roles",
      otherTravellers: "Other Travellers",
    },
    reminderModal: {
      choose: "Choose a reminder token:",
      good: "Good",
      evil: "Evil",
      customNote: "Custom Note",
      customNotePrompt: "Add a custom reminder note",
    },
    npcModal: {
      choose: "Choose a {type} character to add to the game:",
    },
    editionModal: {
      selectEdition: "Select an edition:",
      customScriptCharacters: "Custom Script / Characters",
      loadCustom: "Load custom script / characters",
      customIntro:
        "To write your own custom script, select the characters you want to play with in the official {scriptTool} and then upload the generated JSON directly here or provide a URL to a hosted file. Popular custom scripts can be found at {botcScripts}.",
      customIntroStart:
        "To write your own custom script, select the characters you want to play with in the official",
      customIntroAfterScript:
        "and then upload the generated JSON directly here or provide a URL to a hosted file. Popular custom scripts can be found at",
      homebrewIntro:
        "To play with your own homebrew characters, please read {documentation} on how to write a custom character JSON object.",
      homebrewIntroStart:
        "To play with your own homebrew characters, please read",
      homebrewIntroAfterDocs:
        "on how to write a custom character JSON object.",
      scriptTool: "Script Tool",
      documentation: "the documentation",
      trustWarning: "Only load JSON files from sources that you trust!",
      popularScripts: "Some popular custom scripts:",
      uploadJson: "Upload JSON",
      enterUrl: "Enter URL",
      useClipboard: "Use JSON from Clipboard",
      teensyville: "Teensyville",
      urlPrompt: "Enter URL to a custom-script.json file",
      readError: "Error reading custom script: {message}",
      loadError: "Error loading custom script: {message}",
    },
    rolesModal: {
      selectCharacters: "Select the characters for {count} players:",
      allowDuplicates: "Allow duplicate characters",
      assignRandomly: "Assign {count} characters randomly",
      mockAssignment: "Mock assignment",
      passOutRandomly: "Pass out {count} characters randomly",
      shuffleCharacters: "Shuffle characters",
      illegalWarning:
        "Warning: there are characters selected that cannot be sent to players! You will not be able to distribute characters until these characters are removed.",
      setupWarning:
        "Warning: there are characters selected that modify the game setup! The randomizer does not account for these characters.",
      confirmDisconnected:
        "WARNING: Some players have not yet taken their seats. Are you sure you want to assign and distribute characters?",
      confirmDistribute:
        "Do you want to assign and distribute characters to all players?",
    },
    reference: {
      showNightOrder: "Show Night Order",
      characterReference: "Character Reference",
      rules: "Rules",
      jinxed: "Jinxed",
    },
    nightOrder: {
      showReference: "Show Character Reference",
      title: "Night Order",
      firstNight: "First Night",
      otherNights: "Other Nights",
      dusk: "Dusk",
      dawn: "Dawn",
      startNight: "Start the Night Phase.",
      endNight: "Wait a few seconds. End the Night Phase.",
      minionInfo: "Minion info",
      demonInfoBluffs: "Demon info & bluffs",
      minionReminder:
        "If there are 7 or more players, wake all Minions: Show the *THIS IS THE DEMON* token. Point to the Demon. Show the *THESE ARE YOUR MINIONS* token. Point to the other Minions.",
      demonReminder:
        "If there are 7 or more players, wake the Demon: Show the *THESE ARE YOUR MINIONS* token. Point to all Minions. Show the *THESE CHARACTERS ARE NOT IN PLAY* token. Show 3 not-in-play good character tokens.",
    },
    gameState: {
      title: "Current Game State",
      copyJson: "Copy JSON",
      loadState: "Load State",
      parseError: "Unable to parse JSON: {message}",
    },
    voteHistory: {
      clearTitle: "Clear vote history",
      title: "Vote history",
      accessible: "Accessible to players",
      clearEveryone: "Clear for everyone",
      time: "Time",
      day: "Day",
      dayHeading: "Day {number}",
      nominator: "Nominator",
      nominee: "Nominee",
      type: "Type",
      votes: "Votes",
      majority: "Majority",
      voters: "Voters",
      execution: "Execution",
      exile: "Exile",
    },
    socket: {
      distributeFailed:
        "Unable to distribute roles: the selected player is not connected.",
      missingRoles:
        "This session contains custom characters that can't be found. Please load them before joining! Missing roles: {roles}",
    },
  },
  ru: {
    meta: {
      htmlLang: "ru",
      language: "Russian",
    },
    app: {
      titlePublic: "Blood on the Clocktower: городская площадь",
      titleGrimoire: "Blood on the Clocktower: гримуар",
    },
    common: {
      back: "Назад",
      by: "от",
      close: "Закрыть",
      customScript: "Пользовательский сценарий",
      search: "Поиск",
    },
    language: {
      label: "Язык",
      english: "Английский",
      russian: "Русский",
    },
    teams: {
      townsfolk: "Горожане",
      outsider: "Изгои",
      minion: "Приспешники",
      demon: "Демоны",
      traveller: "Странники",
      fabled: "Сказочники",
      loric: "Летописцы",
      jinxed: "Сглазы",
    },
    intro: {
      welcome: "Добро пожаловать в неофициальные",
      title: "Виртуальную городскую площадь и гримуар",
      forClocktower: "для Blood on the Clocktower!",
      addPlayersBeforeMenu: "Добавьте игроков через",
      menu: "Меню",
      addPlayersAfterMenu:
        "в правом верхнем углу или нажмите {addKey}. Также можно присоединиться к сессии клавишей {joinKey}.",
      footerBeforeGithub:
        "Этот проект бесплатный, с открытым исходным кодом и доступен на",
      footerAfterGithub:
        "Проект не связан с The Pandemonium Institute. Blood on the Clocktower является товарным знаком Steven Medway и The Pandemonium Institute.",
      chineseRedirect: "Хотите использовать китайскую версию?",
    },
    menu: {
      recentNominations: [
        "{count} недавняя номинация",
        "{count} недавние номинации",
        "{count} недавних номинаций",
      ],
      sessionSummary: "{count} других игроков в этой сессии",
      sessionLatency: "задержка {latency} мс",
      grimoire: "Гримуар",
      hide: "Скрыть",
      show: "Показать",
      switchToNight: "Перейти к ночи",
      switchToDay: "Перейти ко дню",
      nightOrder: "Порядок ночи",
      zoom: "Масштаб",
      backgroundImage: "Фоновое изображение",
      useUnofficialArt: "Неофициальные иллюстрации",
      showCustomImages: "Показывать изображения сценария",
      disableAnimations: "Отключить анимации",
      muteSounds: "Отключить звук",
      playing: "Играете",
      hosting: "Сессия",
      liveSession: "Живая сессия",
      host: "Создать (Рассказчик)",
      join: "Войти (игрок)",
      delayToHost: "Задержка до ведущего",
      delayToPlayers: "Задержка до игроков",
      copyPlayerLink: "Скопировать ссылку игрокам",
      sendCharacters: "Отправить роли",
      voteHistory: "История голосований",
      secretVote: "Скрытое голосование",
      votingTwice: "Двойные голоса",
      leaveSession: "Покинуть сессию",
      players: "Игроки",
      add: "Добавить",
      allowSelfNaming: "Игроки могут менять имена",
      lowerAllHands: "Опустить все руки",
      randomize: "Перемешать",
      removeAll: "Удалить всех",
      characters: "Персонажи",
      selectEdition: "Выбрать издание",
      chooseAssign: "Выбрать и назначить",
      addNpcs: "Добавить NPC",
      clearAll: "Очистить все",
      help: "Помощь",
      referenceSheet: "Справочник персонажей",
      nightOrderSheet: "Лист ночи",
      gameStateJson: "JSON состояния",
      mockAssignments: "Тестовые назначения",
      joinDiscord: "Неофициальный Discord",
      sourceCode: "Исходный код",
      prompts: {
        background: "Введите URL фонового изображения",
        sessionHost: "Введите номер или название канала для сессии",
        sessionJoin: "Введите номер, название или ссылку на сессию",
        distributeRoles:
          "Отправить назначенные роли всем игрокам, занявшим места?",
        imageOptIn:
          "Разрешить пользовательские изображения? Автор вредоносного сценария может отследить ваш IP-адрес таким образом.",
        leaveSession: "Покинуть активную игру?",
        playerName: "Имя игрока",
        defaultPlayerName: "Игрок {number}",
        randomizeSeats: "Перемешать рассадку?",
        removePlayers: "Удалить всех игроков?",
        removeRoles: "Удалить все роли игроков?",
      },
    },
    townInfo: {
      addMorePlayers: "Добавьте больше игроков!",
      nightPhase: "Ночная фаза",
      editionByAuthor: "{name} от {author}",
    },
    townSquare: {
      otherCharacters: "Другие персонажи",
      demonBluffs: "Блефы Демона",
      npcs: "NPC",
      removePlayer: "Удалить игрока {name}?",
      firstNight: "Первая ночь",
      otherNights: "Остальные ночи",
    },
    player: {
      ghostVote: "Призрачный голос",
      hasTwoVotes: "Есть два голоса",
      wasNominated: "Номинирован",
      hasNominated: "Номинировал",
      handUp: "Рука поднята",
      secondHandUp: "Вторая рука поднята",
      handDown: "Рука опущена",
      voteUnknown: "Голос скрыт",
      cancel: "Отмена",
      swapWithPlayer: "Поменяться местами с этим игроком",
      moveToSeat: "Переместить игрока на это место",
      nominatePlayer: "Номинировать этого игрока",
      raiseHand: "Поднять руку",
      changeAlignment: "Изменить сторону",
      changePronouns: "Изменить местоимения",
      rename: "Переименовать",
      movePlayer: "Переместить игрока",
      swapSeats: "Поменять места",
      remove: "Удалить",
      emptySeat: "Освободить место",
      cancelNomination: "Отменить номинацию",
      nomination: "Номинация",
      claimSeat: "Занять место",
      vacateSeat: "Освободить место",
      seatOccupied: "Место занято",
      pronounsPrompt: "Местоимения игрока",
      namePrompt: "Имя игрока",
      yourClaimedSeat: "Ваше занятое место",
      seatClaimedBy: "Место занято: {name}",
      yourReservedSeat: "Ваше зарезервированное место. Нажмите «Занять место», чтобы переподключиться",
      seatReservedFor: "Место зарезервировано для {name}",
    },
    vote: {
      nominated: "номинирует",
      votes: ["{count} голос", "{count} голоса", "{count} голосов"],
      inFavor: "за",
      secretInProgress: "Голосование скрыто",
      majorityIs: "большинство: {count}",
      timePerPlayer: "Время на игрока:",
      unoccupiedSeats: "Некоторые места не заняты",
      countdown: "Отсчет",
      restart: "Перезапустить",
      start: "Начать",
      pause: "Пауза",
      resume: "Продолжить",
      reset: "Сброс",
      markForExecution: "Отметить для казни",
      clearMark: "Снять отметку",
      secondsBetweenVotes: "{count} секунд между голосами",
      claimSeat: "Займите место, чтобы голосовать.",
      reclaimSeat: "Верните свое место, чтобы голосовать.",
      go: "ГОЛОСУЙТЕ",
    },
    timer: {
      title: "Таймер",
      presets: "Быстрый выбор времени",
      minutes: "Минуты",
      seconds: "Секунды",
      minutesShort: "мин",
      secondsShort: "сек",
      adjustTime: "Настройка времени",
      sound: "Подать звуковой сигнал по окончании",
      start: "Запустить",
      pause: "Пауза",
      resume: "Продолжить",
      stop: "Остановить",
      close: "Закрыть",
      addThirtySeconds: "+30 секунд",
      subtractThirtySeconds: "-30 секунд",
      addMinute: "+1 минута",
      subtractMinute: "-1 минута",
      remaining: "осталось",
      paused: "пауза",
      timeUp: "время вышло",
      openControls: "Открыть управление таймером",
    },
    dayTracker: {
      title: "День и ночь",
      day: "День",
      night: "Ночь",
      dayLabel: "День {number}",
      nightLabel: "Ночь {number}",
      notStarted: "Игра не начата",
      phaseNumber: "Номер",
      decreaseNumber: "Уменьшить номер фазы",
      increaseNumber: "Увеличить номер фазы",
      openCorrection: "Открыть корректировку дня и ночи",
      sequenceHint:
        "Игра начинается с Ночи 1, затем наступает День 1. Если переключились случайно, выберите нужную фазу и исправьте её номер.",
      hasNominated: "Игрок уже номинировал сегодня",
      wasNominated: "Игрок уже был номинирован сегодня",
      warnings: {
        deadNominator: "номинирующий игрок мёртв",
        nominatorUsed: "игрок уже номинировал сегодня",
        nomineeUsed: "этого игрока уже номинировали сегодня",
        override:
          "Обычно эта номинация недоступна:\n{reasons}\n\nПродолжить как эффект персонажа или исключение ведущего?",
      },
    },
    roleModal: {
      regular: "Обычная",
      good: "Добро",
      evil: "Зло",
      chooseCharacterFor: "Выберите нового персонажа для {name}:",
      bluffing: "блефа",
      editionRoles: "Роли издания",
      otherTravellers: "Другие Странники",
    },
    reminderModal: {
      choose: "Выберите жетон напоминания:",
      good: "Добро",
      evil: "Зло",
      customNote: "Своя заметка",
      customNotePrompt: "Добавьте свою заметку-напоминание",
    },
    npcModal: {
      choose: "Выберите персонажа типа «{type}» для добавления в игру:",
    },
    editionModal: {
      selectEdition: "Выберите издание:",
      customScriptCharacters: "Пользовательский сценарий / персонажи",
      loadCustom: "Загрузить пользовательский сценарий / персонажей",
      customIntro:
        "Чтобы создать свой сценарий, выберите персонажей в официальном {scriptTool}, а затем загрузите JSON сюда или укажите URL файла. Популярные пользовательские сценарии можно найти на {botcScripts}.",
      customIntroStart:
        "Чтобы создать свой сценарий, выберите персонажей в официальном",
      customIntroAfterScript:
        "и загрузите JSON сюда или укажите URL файла. Популярные пользовательские сценарии можно найти на",
      homebrewIntro:
        "Чтобы играть со своими персонажами, прочитайте {documentation} о формате JSON для пользовательских персонажей.",
      homebrewIntroStart: "Чтобы играть со своими персонажами, прочитайте",
      homebrewIntroAfterDocs:
        "о формате JSON для пользовательских персонажей.",
      scriptTool: "Script Tool",
      documentation: "документацию",
      trustWarning: "Загружайте JSON только из источников, которым доверяете!",
      popularScripts: "Популярные пользовательские сценарии:",
      uploadJson: "Загрузить JSON",
      enterUrl: "Ввести URL",
      useClipboard: "Взять JSON из буфера",
      teensyville: "Teensyville",
      urlPrompt: "Введите URL файла custom-script.json",
      readError: "Ошибка чтения пользовательского сценария: {message}",
      loadError: "Ошибка загрузки пользовательского сценария: {message}",
    },
    rolesModal: {
      selectCharacters: "Выберите персонажей для {count} игроков:",
      allowDuplicates: "Разрешить дубликаты персонажей",
      assignRandomly: "Назначить {count} персонажей случайно",
      mockAssignment: "Тестовое назначение",
      passOutRandomly: "Раздать {count} персонажей случайно",
      shuffleCharacters: "Перемешать персонажей",
      illegalWarning:
        "Внимание: выбраны персонажи, которых нельзя отправить игрокам. Вы не сможете раздать роли, пока не удалите этих персонажей.",
      setupWarning:
        "Внимание: выбраны персонажи, изменяющие подготовку игры. Рандомизатор не учитывает эти изменения.",
      confirmDisconnected:
        "ВНИМАНИЕ: некоторые игроки еще не заняли места. Назначить и раздать персонажей?",
      confirmDistribute:
        "Назначить и раздать персонажей всем игрокам?",
    },
    reference: {
      showNightOrder: "Показать порядок ночи",
      characterReference: "Справочник персонажей",
      rules: "Правила",
      jinxed: "Сглазы",
    },
    nightOrder: {
      showReference: "Показать справочник персонажей",
      title: "Порядок ночи",
      firstNight: "Первая ночь",
      otherNights: "Остальные ночи",
      dusk: "Сумерки",
      dawn: "Рассвет",
      startNight: "Начните ночную фазу.",
      endNight: "Подождите несколько секунд. Завершите ночную фазу.",
      minionInfo: "Информация Приспешникам",
      demonInfoBluffs: "Информация Демону и блефы",
      minionReminder:
        "Если игроков 7 или больше, разбудите всех Приспешников: покажите жетон *ЭТО ДЕМОН*. Укажите на Демона. Покажите жетон *ЭТО ВАШИ ПРИСПЕШНИКИ*. Укажите на остальных Приспешников.",
      demonReminder:
        "Если игроков 7 или больше, разбудите Демона: покажите жетон *ЭТО ВАШИ ПРИСПЕШНИКИ*. Укажите на всех Приспешников. Покажите жетон *ЭТИХ ПЕРСОНАЖЕЙ НЕТ В ИГРЕ*. Покажите 3 добрых персонажей не в игре.",
    },
    gameState: {
      title: "Текущее состояние игры",
      copyJson: "Копировать JSON",
      loadState: "Загрузить состояние",
      parseError: "Не удалось разобрать JSON: {message}",
    },
    voteHistory: {
      clearTitle: "Очистить историю голосований",
      title: "История голосований",
      accessible: "Доступно игрокам",
      clearEveryone: "Очистить у всех",
      time: "Время",
      day: "День",
      dayHeading: "День {number}",
      nominator: "Номинатор",
      nominee: "Номинант",
      type: "Тип",
      votes: "Голоса",
      majority: "Большинство",
      voters: "Голосовавшие",
      execution: "Казнь",
      exile: "Изгнание",
    },
    socket: {
      distributeFailed:
        "Не удалось раздать роли: выбранный игрок не подключен.",
      missingRoles:
        "В этой сессии есть пользовательские персонажи, которые не найдены. Загрузите их перед подключением. Не найдены роли: {roles}",
    },
  },
};

export default messages;
